// extracted by mini-css-extract-plugin
export default {"underline":"UnderlineAnimation_underline__vC4iv","myAnimation":"UnderlineAnimation_myAnimation__ADeWL"};